/* unplugin-vue-components disabled */import { render } from "./ContentTile.vue?vue&type=template&id=5285d070&scoped=true&ts=true"
import script from "./ContentTile.vue?vue&type=script&lang=ts"
export * from "./ContentTile.vue?vue&type=script&lang=ts"

import "./ContentTile.vue?vue&type=style&index=0&id=5285d070&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5285d070"]])

export default __exports__